import { defaultQueryOptions } from 'constants/'
import { useQuery } from 'react-query'
import { QueryOptions } from 'types'
import { findLatestOpportunities, logFactory } from 'utils'
import { useOpportunityService } from '../services'
import { useFeatureFlags } from '@audibene/ta.react-feature-flags'

const latestOpportunityHookName = 'useLatestOpportunity'
const latestOpportunityLog = logFactory(latestOpportunityHookName)

const useLatestOpportunity = (
  customerGid?: string,
  options: QueryOptions & { skipFitterScope?: boolean } = { enabled: Boolean(customerGid) }
) => {
  const [isNeoEnabled] = useFeatureFlags(['NEO'])
  const { getLatestOpportunities, getCurrentOpportunity } = useOpportunityService({
    skipFitterScope: options.skipFitterScope,
  })

  const doQuery = async () => {
    const params = {
      customerSalesforceId: [customerGid as string],
    }

    latestOpportunityLog(`🕰️ Fetching latest opportunities...`, params)

    const { data } = await getLatestOpportunities(params)

    const { data: currentOpportunity } = await getCurrentOpportunity(params)

    const [found] = findLatestOpportunities(data, currentOpportunity?.[0], isNeoEnabled)

    latestOpportunityLog(`🕰️ Found opportunities`, found)
    return found
  }

  return useQuery([latestOpportunityHookName, customerGid], doQuery, {
    ...defaultQueryOptions,
    ...options,
  })
}

export { useLatestOpportunity }
